import request from 'common/request';
import ACTION_ITEMS from '../actionItems';

export function technicalCheckIfDone() {
  return (dispatch) => {
    request
      .get('/technical-assessment/checkIfDone')
      .then(function(response) {
        const { redirect, isDone } = response.data;
        if (redirect) {
          window.location = './login';
        } else {
          dispatch(technicalCheckIfDoneSuccess(isDone));
        }
      })
      .catch(function(error) {
        console.error(error);
      });
  };
}

function technicalCheckIfDoneSuccess(isDone) {
  return {
    type: ACTION_ITEMS.NAVBAR.TECHNICAL_DONE.SET,
    payload: {
      isDone,
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/navbar/actions/technicalCheckIfDone.js